export const ODS_TRANSITION_MODAL_ID = 'ods-transition-modal'
